import { PREFECTURE_NAME_TO_ID } from '../../Prefecture/constant'

type PrefectureName = keyof typeof PREFECTURE_NAME_TO_ID

type PrefectureOptionGroup = {
    region: string
    prefectures: { id: number; name: string }[]
    // 「選択してください」をこのグループ内の何番目に挟むか（デザイナー注記「デフォルトが関東付近」の実装）
    placeholderIndex?: number
}

// Prefecture::REGION_MAP は8区分でデザインの6区分と異なるため、FE側で定義する
const REGIONS: { region: string; names: PrefectureName[] }[] = [
    {
        region: '北海道・東北',
        names: ['北海道', '青森県', '岩手県', '宮城県', '秋田県', '山形県', '福島県'],
    },
    {
        region: '関東',
        names: [
            '茨城県',
            '栃木県',
            '群馬県',
            '埼玉県',
            '千葉県',
            '東京都',
            '神奈川県',
        ],
    },
    {
        region: '中部',
        names: [
            '新潟県',
            '富山県',
            '石川県',
            '福井県',
            '山梨県',
            '長野県',
            '岐阜県',
            '静岡県',
            '愛知県',
        ],
    },
    {
        region: '近畿',
        names: ['三重県', '滋賀県', '京都府', '大阪府', '兵庫県', '奈良県', '和歌山県'],
    },
    {
        region: '中国・四国',
        names: [
            '鳥取県',
            '島根県',
            '岡山県',
            '広島県',
            '山口県',
            '徳島県',
            '香川県',
            '愛媛県',
            '高知県',
        ],
    },
    {
        region: '九州・沖縄',
        names: [
            '福岡県',
            '佐賀県',
            '長崎県',
            '熊本県',
            '大分県',
            '宮崎県',
            '鹿児島県',
            '沖縄県',
        ],
    },
]

// 未選択の初期表示を関東付近にするため、「選択してください」は千葉県と東京都の間に置く
const PLACEHOLDER_REGION = '関東'
const PLACEHOLDER_AFTER = '千葉県'

export const PREFECTURE_OPTION_GROUPS: PrefectureOptionGroup[] = REGIONS.map(
    ({ region, names }) => ({
        region,
        prefectures: names.map(name => ({
            id: PREFECTURE_NAME_TO_ID[name],
            name,
        })),
        placeholderIndex:
            region === PLACEHOLDER_REGION
                ? names.indexOf(PLACEHOLDER_AFTER) + 1
                : undefined,
    })
)
